
// Mapping utilities for Twilio call statuses to database statuses

import type { CallLog } from '@/types/callLog';

export const mapTwilioStatusToCallStatus = (twilioStatus: string): CallLog['call_status'] => {
  switch (twilioStatus.toLowerCase()) {
    case 'connecting':
    case 'initiating':
      return 'connecting';
    case 'ringing':
      return 'ringing';
    case 'open':
    case 'in-progress':
      return 'in-progress'; // Changed from 'completed' to 'in-progress'
    case 'completed':
    case 'ended':
      return 'completed';
    case 'failed':
    case 'error':
      return 'failed';
    case 'busy':
      return 'busy';
    case 'no-answer':
    case 'timeout':
      return 'no-answer';
    case 'cancelled':
    case 'cancel':
      return 'cancelled';
    default:
      console.warn(`Unknown Twilio status: ${twilioStatus}, defaulting to 'unknown'`);
      return 'unknown';
  }
};

export const generateBasicSummary = (status: string, duration: number, phoneNumber: string): string => {
  const durationMinutes = Math.floor(duration / 60);
  const durationSeconds = duration % 60;
  const formattedDuration = `${durationMinutes}m ${durationSeconds}s`;

  switch (status) {
    case 'completed':
      return `Call to ${phoneNumber} completed. Duration: ${formattedDuration}`;
    case 'in-progress':
      return `Call to ${phoneNumber} is in progress.`;
    case 'failed':
      return `Call to ${phoneNumber} failed.`;
    case 'busy':
      return `Call to ${phoneNumber} encountered busy signal.`;
    case 'no-answer':
      return `Call to ${phoneNumber} was not answered.`;
    case 'cancelled':
      return `Call to ${phoneNumber} was cancelled.`;
    default:
      return `Call to ${phoneNumber} status: ${status}`;
  }
};

export const generateNextAction = (status: string): string => {
  switch (status) {
    case 'completed':
      return 'Follow up with contact';
    case 'in-progress':
      return 'Continue conversation';
    case 'failed':
      return 'Retry call later';
    case 'busy':
      return 'Try calling again in a few minutes';
    case 'no-answer':
      return 'Leave voicemail or try again later';
    case 'cancelled':
      return 'Reschedule call';
    default:
      return 'Determine next steps';
  }
};
